import React from 'react';

import { flagStyles } from '../settings';

const SvgAS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-216px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAS;
